import { toast } from 'react-toastify';
import { cn } from '@ds';
import { copyToClipboard } from '@/utils/helpers';

type UnosIdButtonProps = {
  donorId: string;
  suffixColor: string;
  caseSuffixes: string;
  onDonorIdClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  containerClassName?: string;
};

export const UnosIdButton = ({
  donorId,
  suffixColor,
  caseSuffixes,
  onDonorIdClick,
  containerClassName = '',
}: UnosIdButtonProps) => {
  const handleCopyDonorId = (e: React.MouseEvent<HTMLButtonElement>) => {
    onDonorIdClick?.(e);
    copyToClipboard(donorId);
    toast.success('Donor ID copied to clipboard');
  };

  return (
    <div className={cn('flex items-center gap-1 font-mono text-3xl text-base-5 leading-none', containerClassName)}>
      <button
        className="font-semibold p-0 m-0 border-0 hover:text-base-20 active:text-base-30"
        onClick={handleCopyDonorId}
        aria-label={`Copy Donor ID ${donorId} to clipboard`}
      >
        {donorId}
      </button>
      {caseSuffixes.split(' ').map((suffix) => (
        <span key={suffix} className={suffixColor}>
          {suffix}
        </span>
      ))}
    </div>
  );
};
